import type { StoryLength } from './story-length';

export type FeatureKey = 'image' | 'audio' | 'video';

export type FeaturePreference = Record<FeatureKey, boolean>;

export type EffectiveFeature = {
  available: boolean;
  allowed: boolean;
  enabled: boolean;
  reason?: string;
};

export type EffectiveFeatures = Record<FeatureKey, EffectiveFeature>;

export type GenerationAccess = {
  guestTrialAvailable: boolean;
  requiresLogin: boolean;
  requiresBalance: boolean;
  adminContact: string;
};

export type AccountSettings = {
  role: 'user' | 'admin';
  plan: { key: string; name: string };
  balanceMicros: string;
  balanceText: string;
  storyLengths?: StoryLength[];
  nickname: string;
  bio: string;
  preferences: FeaturePreference;
  features: EffectiveFeatures;
};

export function canUseProjectTransfer(account: Pick<AccountSettings, 'role' | 'plan'>) {
  return account.role === 'admin' || account.plan.key === 'member';
}

export const DEFAULT_FEATURE_PREFERENCES: FeaturePreference = {
  image: true,
  audio: true,
  video: false,
};
